import { render, staticRenderFns } from "./RegBasicType.vue?vue&type=template&id=e1f3ee8e"
import script from "./RegBasicType.vue?vue&type=script&lang=js"
export * from "./RegBasicType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports